import type { FaireProductEntity } from "../../entity_types/product";

export const p_gkntfc5yap: FaireProductEntity = {
  token: "p_gkntfc5yap",
  type: "product",
  name: "Cotton Candy Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a4085515fa75c733913b7e10aa94c56d59f45b093750411025daf0318f39c351.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62c835edd3a3a84eeede2678058f451aca573ba9dcd9d6bb5c36f74d32588dd8.jpeg",
    "https://cdn.faire.com/fastly/4d925e72b2a57615cbd8ae039e0e25d4b0231227354423dff53fe86bed6904c0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:30.304Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
